(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-accessories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Namespace for accessories to avoid conflicts
  const AccessoriesSection = {
    
    // Carousel Navigation
    initCarousel: function() {
      const carousel = document.querySelector('.accessories-grid');
      const prevButton = document.querySelector('.prev-arrow');
      const nextButton = document.querySelector('.next-arrow');
      const cards = document.querySelectorAll('.accessories-card');
      
      if (!carousel || !prevButton || !nextButton || cards.length === 0) return;

      let currentIndex = 0;
      
      function getCardWidth() {
        return cards[0].offsetWidth + 16; // width + gap
      }
      
      function updateArrowState() {
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= cards.length - getVisibleCards();
      }
      
      function getVisibleCards() {
        const viewportWidth = window.innerWidth;
        if (viewportWidth <= 700) return 1; // Mobile
        if (viewportWidth <= 1024) return 3; // Tablet
        return 4; // Desktop
      }
      
      function scrollToIndex(index) {
        currentIndex = index;
        const scrollAmount = index * getCardWidth();
        carousel.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        });
        updateArrowState();
      }
      
      prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
          scrollToIndex(currentIndex - 1);
        }
      });
      
      nextButton.addEventListener('click', () => {
        if (currentIndex < cards.length - getVisibleCards()) {
          scrollToIndex(currentIndex + 1);
        }
      });
      
      // Initialize arrow states
      updateArrowState();
      
      // Update on window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          currentIndex = 0;
          scrollToIndex(0);
          updateArrowState();
        }, 100);
      });
    },

    // Protected Add to Cart functionality
    initAddToCart: function() {
      const purchaseButtons = document.querySelectorAll('.accessories-purchase-btn');
      
      purchaseButtons.forEach(button => {
        // Remove any existing event listeners to prevent conflicts
        button.replaceWith(button.cloneNode(true));
      });
      
      // Re-select buttons after cloning
      const freshButtons = document.querySelectorAll('.accessories-purchase-btn');
      
      freshButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (this.disabled) return;
          
          const variantId = this.getAttribute('data-variant-id');
          const productTitle = this.getAttribute('data-product-title');
          
          if (!variantId) {
            console.error('No variant ID found');
            return;
          }
          
          AccessoriesSection.addToCart(variantId, productTitle, this);
        });
      });
    },

    // Isolated add to cart function
    addToCart: function(variantId, productTitle, buttonElement) {
      const originalText = buttonElement.textContent;
      buttonElement.textContent = 'Adding...';
      buttonElement.disabled = true;
      
      const cartData = {
        items: [{
          id: parseInt(variantId),
          quantity: 1
        }]
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(cartData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        buttonElement.textContent = 'Added!';
        
        // Update cart UI
        return AccessoriesSection.updateCartDisplay();
      })
      .then(() => {
        // Dispatch custom event for theme compatibility
        document.dispatchEvent(new CustomEvent('accessories:cart-updated', {
          detail: { 
            variantId: variantId,
            productTitle: productTitle 
          }
        }));
        
        setTimeout(() => {
          buttonElement.textContent = originalText;
          buttonElement.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        buttonElement.textContent = 'Error - Try Again';
        
        setTimeout(() => {
          buttonElement.textContent = originalText;
          buttonElement.disabled = false;
        }, 3000);
      });
    },

    // Update cart display
    updateCartDisplay: function() {
      return fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(cartData => {
        // Update sticky cart if it exists
        const stickyItems = document.getElementById('StickyItems');
        if (stickyItems) {
          const itemText = cartData.item_count === 1 ? 'item' : 'items';
          stickyItems.textContent = `${cartData.item_count} ${itemText}`;
        }

        const stickySubtotal = document.getElementById('StickySubtotal');
        if (stickySubtotal) {
          const moneySpan = stickySubtotal.querySelector('.money');
          if (moneySpan) {
            moneySpan.textContent = AccessoriesSection.formatMoney(cartData.total_price);
          }
        }

        const stickyCart = document.getElementById('StickyCart');
        if (stickyCart && cartData.item_count > 0) {
          stickyCart.classList.add('sticky-cart--open');
        }

        // Dispatch standard cart update event for theme compatibility
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: cartData }
        }));
        
        return cartData;
      })
      .catch(error => {
        console.error('Error updating cart display:', error);
      });
    },

    // Format money helper
    formatMoney: function(cents) {
      return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // Initialize everything
    init: function() {
      this.initCarousel();
      this.initAddToCart();
      
      // Initial cart state sync
      this.updateCartDisplay();
    }
  };

  // Initialize the accessories section
  AccessoriesSection.init();
  
  // Re-initialize if the section is dynamically loaded
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.accessories-section')) {
      setTimeout(() => {
        AccessoriesSection.init();
      }, 100);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
